import {css} from 'lit';
export const styles = css`:host {
  display: inline-block;
  line-height: 1;
}

:host([badgeCount]) {
  position: relative;
  font-size: 22px;
}

:host ef-badge {
  position: absolute;
  top: -8px;
  right: -8px;
}
`;
export default styles;
